// Main JavaScript file
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const iconOpen = document.getElementById('icon-open');
  const iconClose = document.getElementById('icon-close');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden');

      if (isOpen) {
        // Mostrar ícono de abrir, ocultar cerrar
        iconOpen.classList.remove('opacity-0', 'pointer-events-none');
        iconOpen.classList.add('opacity-100');
        iconClose.classList.remove('opacity-100');
        iconClose.classList.add('opacity-0', 'pointer-events-none');
      } else {
        // Mostrar ícono de cerrar, ocultar abrir
        iconOpen.classList.remove('opacity-100');
        iconOpen.classList.add('opacity-0', 'pointer-events-none');
        iconClose.classList.remove('opacity-0', 'pointer-events-none');
        iconClose.classList.add('opacity-100');
      }
    });
  }

  // Add to cart functionality
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        
        const variantId = this.dataset.variantId;
        const quantity = parseInt(this.dataset.quantity || '1', 10);
        
        // Optional: Show loading state
        button.classList.add('loading');
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity
              }]
            })
          });
          
          const data = await response.json();
          
          if (response.ok) {
            // Update cart count
            updateCartCount();
            
            // Show success message
            const successMessage = document.createElement('div');
            successMessage.className = 'fixed top-4 right-4 bg-green-500 text-white py-2 px-4 rounded shadow-lg z-50';
            successMessage.textContent = 'Item added to cart!';
            document.body.appendChild(successMessage);
            
            setTimeout(() => {
              successMessage.remove();
            }, 3000);
          } else {
            console.error('Error adding to cart:', data);
            
            // Show error message
            const errorMessage = document.createElement('div');
            errorMessage.className = 'fixed top-4 right-4 bg-red-500 text-white py-2 px-4 rounded shadow-lg z-50';
            errorMessage.textContent = data.description || 'Could not add item to cart';
            document.body.appendChild(errorMessage);
            
            setTimeout(() => {
              errorMessage.remove();
            }, 3000);
          }
        } catch (error) {
          console.error('Error:', error);
        } finally {
          // Remove loading state
          button.classList.remove('loading');
        }
      });
    });
  }
  
  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          
          if (cart.item_count > 0) {
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        });
      });
  }

}); 